module.exports = __webpack_public_path__ + "img/bg-4.7024737e.png";